import t from"react";import e from"antd-mask-input";import a from"classnames";import"antd/lib/input/style/index.css";const s=({className:s,onPaste:m=(t=>t.preventDefault()),...n})=>t.createElement(e,{className:a("perxis-auto-input",s),onPaste:m,...n});export{s as default};
//# sourceMappingURL=InputMask.js.map
